module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "image-l",
    attrs: {
      "id": "front"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_8"
    }
  }), _c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/common.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "bq-a"
  }, [_c('a', {
    attrs: {
      "id": "index1"
    }
  }, [_c('strong', [_vm._v("“TO TASTEFUL PALATES, KEEN APPETITES, AND HEALTHFUL AND CAPACIOUS STOMACHS.”")])])]), _c('a', {
    attrs: {
      "id": "index1"
    }
  }), _c('p', {
    staticClass: "att"
  }, [_c('a', {
    attrs: {
      "id": "index1"
    }
  }), _c('a', {
    attrs: {
      "id": "index2"
    }
  }, [_c('strong', [_vm._v("—WILLIAM KITCHINER,")]), _vm._v(" "), _c('em', [_c('strong', [_vm._v("Apicius Redivivus: Or, The Cook’s Oracle")])]), _vm._v(" "), _c('strong', [_vm._v("(1817)")])])]), _c('a', {
    attrs: {
      "id": "index2"
    }
  }), _c('p', {
    staticClass: "image-b"
  }, [_c('a', {
    attrs: {
      "id": "index2"
    }
  }), _c('a', {
    attrs: {
      "id": "index3"
    }
  }), _c('a', {
    attrs: {
      "id": "page_9"
    }
  }), _c('a', {
    attrs: {
      "id": "f0009-01"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/f0009-01.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "f0009-01"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fe87468a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/front.vue
// module id = 72
// module chunks = 0